import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { theme, getInputFormattedDateFromString } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from './progress.js';
import ReceiptListItem from './receiptListItem.js';
import { Paginator } from './paginator.js';
import SearchInvoice from '../components/searchInvoice.js';

function ClientReceiptInfo(props){
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [filteredReceipts, setFilteredReceipts] = useState(props.client.receipts);
  const [offset, setOffset] = useState(0);
  const [receipts, setReceipts] = useState(props.client.receipts);
  const [description, setDescription] = useState(null);
  const [mode, setMode] = useState('Cash');
  const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState('INR');
  const [notifySms, setNotifySms] = useState(0);
  const [notifyMail, setNotifyMail] = useState(0);
  const [invoice, setInvoice] = useState(null);
  const [createdDate, setCreatedDate] = useState(getInputFormattedDateFromString(Date.now()));

  let searchForm = useRef();

  const handleSearch = (event) => {
    const target = event.target;
    const value = target.value;
    const filtered = [];
    for(let i = 0;i<receipts.length;i++){
      if(value === undefined || value.trim() === '' || receipts[i].description.indexOf(value) >= 0 || receipts[i].updation_date.indexOf(value) >= 0 || receipts[i].amount.indexOf(value) >= 0 || receipts[i].receipt_id.indexOf(value) >= 0){
        filtered.push(receipts[i]);
      }
    }
    setFilteredReceipts(filtered);
  }

  const handleSubmit = (event) =>{
    event.preventDefault();
    if(amount && parseInt(amount) > 0 && description && invoice && parseInt(amount) <= parseInt(invoice.amount - invoice.paid)){
      const formData = new FormData;
      formData.append('description', description);
      formData.append('task', "create");
      formData.append('client', props.id);
      formData.append('invoice', invoice.invoice_id);
      formData.append('amount', amount);
      formData.append('currency', currency);
      formData.append('mode', mode);
      formData.append('notifySms', notifySms);
      formData.append('notifyMail', notifyMail);
      formData.append('createdDate', createdDate);
      formData.append('token', localStorage.getItem("token"));
      setLoading(true);
      axios.post(global.config.api_server+'receipt',formData).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Receipt Created');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
        }else{
          alertService.error(res.data.error);
          setLoading(false);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Fields must have valid values');
      setLoading(false);
    }
  }

  const handleNotifySms = (event) =>{
    if(event.target.checked){
      setNotifySms(1);
    }else{
      setNotifySms(0);
    }
  }

  const handleNotifyMail = (event) =>{
    if(event.target.checked){
      setNotifyMail(1);
    }else{
      setNotifyMail(0);
    }
  }

  const resetSearch = (event) => {
    searchForm.current.reset();
    setSearch('');
    setFilteredReceipts(receipts);
  }

  const onPageChange = (index_start) => {
    setOffset(index_start);
  }  

  let createReceipt = "";
  if(parseInt(localStorage.getItem("role")) >= 3){
    createReceipt = <a href="#" className={'btn btn-icon-split float-right btn-'+theme()} data-toggle="modal" data-target="#createReceiptModal">
                  <span className="icon text-white-50">
                    <i className="fas fa-money-bill-wave"></i>
                  </span>
                  <span className="text">Add New Receipt</span>
                </a>;
  }
  let total = 0;
  let counter = 0;
  let offsetCounter = 0;
  const paginated_receipts = [];
  for (const u of filteredReceipts) {
    total++;
    offsetCounter++;
    if (offsetCounter > offset && counter < global.config.items_per_page){
      counter++;
      paginated_receipts.push(u);
    }
  }
  let balance = 0;
  if(invoice && amount){
    balance = (parseFloat(invoice.amount) - (parseFloat(invoice.paid) + parseFloat(amount)));
  }else if (invoice){
    balance = (parseFloat(invoice.amount) - parseFloat(invoice.paid));
  }

  return(
    <div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          {createReceipt}
          <form ref={searchForm} className="form-inline">
              <h6 className={'form-group mr-3 font-weight-bold text-'+theme()}>Client - Receipts(s)</h6>
              <div className="form-group mr-3">
                <input type="search" label="search" className="form-control" placeholder="Search" onChange={handleSearch}/>
              </div>
              {search &&
              <div className="form-group mr-3">
                <a href="#" className="btn btn-default btn-icon-split" onClick={resetSearch}>
                  <span className="icon">
                    <i className="fas fa-times"></i>
                  </span>
                </a>
              </div>
              }
            </form>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div className="row">
            {loading === true ? (
              <Progress label='Loading..' small={true}/>
            ):null}
              <div className="col-sm-12">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Receipt Id</th> 
                      <th>Additional Note</th>
                      <th>Mode of Payment</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Created On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginated_receipts.map(receipt =>
                      <ReceiptListItem info={receipt} key={receipt.receipt_id} type="client"/>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <Paginator
                itemCount={total}
                itemsPerPage={global.config.items_per_page}
                showNextPages={2}
                showPrevPages={2}
                filterTotal={filteredReceipts.length}
                grandTotal={receipts.length}
                onClick={onPageChange.bind(this)}
              />
          </div>
        </div>
      </div>
      <div className="modal fade" id="createReceiptModal" tabIndex="-1" role="dialog" aria-labelledby="create-popup" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="create-popup">Create Receipt</h5>
              <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <SearchInvoice handleSubmit={(e) => { setInvoice(e); setCurrency(e.currency);}} client={props.id}></SearchInvoice>
                {invoice && 
                  <div>
                    <div class="row">
                      <div class="col-md-6">
                        <div className="form-group">
                          <label>Amount (Balance: {balance})</label>
                          <input type="number" value={amount} maxLength="50" name="amount" className="form-control" id="amount" placeholder="Enter Amount" onChange={(e) => setAmount(e.target.value)}/>
                        </div>
                        <div className="form-group">
                          <label>Currency</label>
                          <select value={currency} name="currency" className="form-control" onChange={(e) => setCurrency(e.target.value)}>
                            {global.config.currencies.split(",").map(d =>
                                <option value={d} key={d}>{d}</option>
                            )}
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div className="form-group">
                          <label>Mode of Payment</label>
                          <select name="mode" className="form-control" id="mode" value={mode} onChange={(e) => setMode(e.target.value)}>
                            <option value="Cash">Cash</option>
                            <option value="Cheque">Cheque</option>
                            <option value="Online">Online</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label>Created Date</label>
                          <input type="date" value={createdDate} maxLength="50" name="createdDate" className="form-control" id="createdDate" placeholder="Enter Created Date" onChange={(e) => setCreatedDate(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Additional Note</label>
                      <textarea maxLength="400" name="description" className="form-control textarea-lg" id="description" placeholder="Additional Note" onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="form-group">
                      <input type="checkbox" onChange={(e) => handleNotifyMail(e)}/> Send Mail &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" onChange={(e) => handleNotifySms(e)}/> Send SMS
                    </div>
                  </div>
                }
                {loading === true ? (
                  <Progress label='Creating..' small={true}/>
                ):null}
              </div>
              <div className="modal-footer">
                <button className="btn btn-default" type="reset" data-dismiss="modal">Close</button>
                <button className={'btn btn-'+theme()} type="button" onClick={handleSubmit}>Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientReceiptInfo;